// @flow

export type Colors = {
  white: string,
  primaryWhite: string,
  black: string,
  amethyst: string,
  azure: string,
  battleship: string,
  dishRed: string,
  emerald: string,
  frenchRose: string,
  honey: string,
  onyx: string,
  progressBar: string,
  royalBlue: string,
  silver: string,
  sunflower: string,
  teal: string,

  hover: string,
  dropdown: string,
  dropdownHover: string,

  success: string,
  warning: string,
  error: string,
};

const colors = {
  white: '#ffffff',
  primaryWhite: 'rgba(255,255,255,0.9)',
  black: '#000000',
  amethyst: '#9b59b6',
  azure: '#3498db',
  battleship: '#808080',
  emerald: '#2ecc71',
  frenchRose: '#e94884',
  honey: '#ffa000',
  onyx: '#181818',
  progressBar: '#777777',
  royalBlue: '#0e64f1',
  silver: '#c7c7c7',
  sunflower: '#f1c40f',
  teal: '#1abc9c',

  hover: '#e41932',
  dropdown: '#404142',
  dropdownHover: '#323334',

  success: '#00b594',
  warning: '#ffa000',
  error: '#d92044',

  // newest dany colors
  veryDarkGrey: '#101010',
  darkGrey: '#222324',
  mediumGrey: '#323334',
  grey: '#404142',

  dishRed: '#e41932',
  blue: '#3498db',
  lightGreen: '#2bffaf',
  green: '#00b594',

  // text colors
  veryLightGrey: '#f1f3f5',
  lightGrey: '#919395',
  mobileTitle: '#b0b0b0',

  kidsBlue: '#44c4ff',
};

export default colors;
